export default __webpack_public_path__ + "static/media/er4.94abf2ed.jpg";